module.exports = __webpack_public_path__ + "img/transport_pic03.fab73055.jpg";